var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Products"}},[_c('select-product',{attrs:{"form":_vm.form},model:{value:(_vm.section.options.content.orderForm.products),callback:function ($$v) {_vm.$set(_vm.section.options.content.orderForm, "products", $$v)},expression:"section.options.content.orderForm.products"}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Fields Style"}},[_c('order-form-field-style',{attrs:{"section":_vm.section}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Steps","group":""}},[_c('b-form-group',{attrs:{"label":"How many steps?"}},[_c('v-select',{style:({ width: '76px', height: '38px !important' }),attrs:{"value":_vm.steps,"options":[1, 2, 3, 4]},on:{"input":_vm.updateWizardCount}})],1),(_vm.form.step !== 99 && _vm.section.options.content.orderForm.stepType !== 'hide')?_c('b-form-group',{attrs:{"label":"Step Title"}},[_c('b-input',{style:({ height: '38px !important' }),model:{value:(_vm.section.options.content.orderForm.steps[_vm.form.step].options.name),callback:function ($$v) {_vm.$set(_vm.section.options.content.orderForm.steps[_vm.form.step].options, "name", $$v)},expression:"section.options.content.orderForm.steps[form.step].options.name"}})],1):_vm._e(),_c('wizard-rule-tabs',{attrs:{"steps":_vm.section.options.content.orderForm.steps.length,"active":_vm.form.step,"current-step":_vm.form.step,"show-confirmation":false},on:{"change":step => _vm.SET_STEP({id: _vm.section.uid, step: step})}}),_c('v-select',{staticClass:"custom-select mb-[16px]",style:({ height: '38px !important' }),attrs:{"options":_vm.stepTypes,"reduce":item => item.value,"lang":"label","placeholder":"Select Step Type"},model:{value:(_vm.section.options.content.orderForm.stepType),callback:function ($$v) {_vm.$set(_vm.section.options.content.orderForm, "stepType", $$v)},expression:"section.options.content.orderForm.stepType"}}),(_vm.section.options.content.orderForm.stepType === 'tabs')?_c('rule-tabs',{attrs:{"tabs":['Active', 'Inactive', 'Hover']},scopedSlots:_vm._u([{key:"Inactive",fn:function(){return [_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--step`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--step`}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--step`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Font Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--step`}})],1)]),_c('sid-align',{attrs:{"label":"Text Alignment","rule-name":"text-align","sid":`.--${_vm.section.sid}--step .step-title`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"rule-name":"font","sid":`.--${_vm.section.sid}--step .step-title`}})],1)]),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--step`,"default-color":"#ededed"}}),_c('sid-flex-direction',{attrs:{"sid":`.--${_vm.section.sid}--header .form-wizard-steps`,"rule-name":"flex-direction"}})]},proxy:true},{key:"Active",fn:function(){return [_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--step.active`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--step.active`}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--step.active`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Font Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--step.active`}})],1)]),_c('sid-align',{attrs:{"label":"Text Alignment","rule-name":"text-align","sid":`.--${_vm.section.sid}--step.active .step-title`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"rule-name":"font","sid":`.--${_vm.section.sid}--step.active .step-title`}})],1)]),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--step.active`,"default-color":"#ffffff"}})]},proxy:true},{key:"Hover",fn:function(){return [_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--step`,"presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--step`,"presudo":":hover"}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--step`,"presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Font Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--step`,"presudo":":hover"}})],1)]),_c('sid-align',{attrs:{"label":"Text Alignment","rule-name":"text-align","sid":`.--${_vm.section.sid}--step .step-title`,"presudo":":hover"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"rule-name":"font","sid":`.--${_vm.section.sid}--step .step-title`,"presudo":":hover"}})],1)]),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--step`,"presudo":":hover","default-color":"#ffffff"}})]},proxy:true}],null,false,4239922308)}):_vm._e(),(_vm.section.options.content.orderForm.stepType === 'progress')?[_c('SidbearSettingsGroup',{attrs:{"title":"Progress Counter"}},[_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--progress .progress-counter`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--progress .progress-counter`}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--progress .progress-counter`}}),_c('sid-range-slider',{attrs:{"label":"Line Height","rule-name":"line-height","sid":`.--${_vm.section.sid}--progress .progress-counter`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Font Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--progress .progress-counter`}})],1)]),_c('sid-align',{attrs:{"label":"Text Alignment","rule-name":"text-align","sid":`.--${_vm.section.sid}--progress .progress-counter`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"rule-name":"font","sid":`.--${_vm.section.sid}--progress .progress-counter`}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Progress Title"}},[_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--progress .progress-title`}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--progress .progress-title`}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--progress .progress-title`}}),_c('sid-range-slider',{attrs:{"label":"Line Height","rule-name":"line-height","sid":`.--${_vm.section.sid}--progress .progress-title`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Font Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":`.--${_vm.section.sid}--progress .progress-title`}})],1)]),_c('sid-align',{attrs:{"label":"Text Alignment","rule-name":"text-align","sid":`.--${_vm.section.sid}--progress .progress-title`}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"p-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"rule-name":"font","sid":`.--${_vm.section.sid}--progress .progress-title`}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Progress Bar"}},[_c('sid-background',{attrs:{"label":"Background Color","sid":`.--${_vm.section.sid}--progress .progress`,"default-color":"#E7EDF8"}}),_c('sid-background',{attrs:{"label":"Active Color","sid":`.--${_vm.section.sid}--progress .progress-bar`,"default-color":"#E7EDF8"}}),_c('sid-range-slider',{attrs:{"label":"Width","sid":`.--${_vm.section.sid}--progress .progress`,"rule-name":"width","var":"--width","default-dimension":"%","dimensions":['px', '%'],"measurement":"width"}}),_c('sid-range-slider',{attrs:{"label":"Height","sid":`.--${_vm.section.sid}--progress .progress`,"rule-name":"height","var":"--height","default-dimension":"px","dimensions":[]}}),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--progress .progress`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Background"}},[_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--progress`,"default-color":"#ffffff"}})],1)]:_vm._e(),(_vm.section.options.content.orderForm.stepType !== 'hide')?_c('SidbearSettingsGroup',{attrs:{"title":"Step Border"}},[_c('rule-tabs',{attrs:{"tabs":['Active', 'Inactive', 'Hover']},scopedSlots:_vm._u([{key:"Inactive",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--step`,"rule-name":"border-style","searchable":false,"options":[
                  {
                    label: 'Solid',
                    value: 'solid'
                  }, 
                  {
                    label: 'Dashed', 
                    value: 'dashed'
                  }, 
                  {
                    label: 'Dotted', 
                    value: 'dotted'
                  }, 
                  {
                    label: 'Double', 
                    value: 'double'
                  }, 
                  {
                    label: 'Outset', 
                    value: 'outset'
                  }
                ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--step`,"label":"Border Width","rule-name":"border","angles":[
                {
                  text: '',
                  value: 'top-width',
                  cssVar: '--border-top-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-top', 'var(--border-top-width)']], [`.--${_vm.section.sid}--header`, ['margin-top', '-' + 'var(--border-top-width)']]]
                },
                {
                  text: '',
                  value: 'right-width',
                  cssVar: '--border-right-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-right', 'var(--border-right-width)']], [`.--${_vm.section.sid}--header`, ['margin-right', '-' + 'var(--border-right-width)']]]
                },
                {
                  text: '',
                  value: 'bottom-width',
                  cssVar: '--border-bottom-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-bottom', 'var(--border-bottom-width)']], [`.--${_vm.section.sid}--header`, ['margin-bottom', '-' + 'var(--border-bottom-width)']]]
                },
                {
                  text: '',
                  value: 'left-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--step`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--step`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
              {
                text: '',
                value: 'top-left-radius',
                cssVar: '--border-top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius',
                cssVar: '--border-top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius',
                cssVar: '--border-bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius',
                cssVar: '--border-bottom-right-radius'
              }
            ]}})]},proxy:true},{key:"Active",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--step.active`,"rule-name":"border-style","searchable":false,"options":[
                  {
                    label: 'Solid',
                    value: 'solid'
                  },
                  {
                    label: 'Dashed',
                    value: 'dashed'
                  },
                  {
                    label: 'Dotted',
                    value: 'dotted'
                  },
                  {
                    label: 'Double',
                    value: 'double'
                  },
                  {
                    label: 'Outset',
                    value: 'outset'
                  }
                ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--step.active`,"label":"Border Width","rule-name":"border","angles":[
                {
                  text: '',
                  value: 'top-width',
                  cssVar: '--border-top-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-top', 'var(--border-top-width)']], [`.--${_vm.section.sid}--header`, ['margin-top', '-' + 'var(--border-top-width)']]]
                },
                {
                  text: '',
                  value: 'right-width',
                  cssVar: '--border-right-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-right', 'var(--border-right-width)']], [`.--${_vm.section.sid}--header`, ['margin-right', '-' + 'var(--border-right-width)']]]
                },
                {
                  text: '',
                  value: 'bottom-width',
                  cssVar: '--border-bottom-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-bottom', 'var(--border-bottom-width)']], [`.--${_vm.section.sid}--header`, ['margin-bottom', '-' + 'var(--border-bottom-width)']]]
                },
                {
                  text: '',
                  value: 'left-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--step.active`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--step.active`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
              {
                text: '',
                value: 'top-left-radius',
                cssVar: '--border-top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius',
                cssVar: '--border-top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius',
                cssVar: '--border-bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius',
                cssVar: '--border-bottom-right-radius'
              }
            ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--step`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                  {
                    label: 'Solid', 
                    value: 'solid'
                  }, 
                  {
                    label: 'Dashed', 
                    value: 'dashed'
                  }, 
                  {
                    label: 'Dotted', 
                    value: 'dotted'
                  }, 
                  {
                    label: 'Double', 
                    value: 'double'
                  }, 
                  {
                    label: 'Outset', 
                    value: 'outset'
                  }
                ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--step`,"label":"Border Width","rule-name":"border-width","presudo":":hover","angles":[
                {
                  text: '',
                  value: 'top-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                },
                {
                  text: '',
                  value: 'right-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                },
                {
                  text: '',
                  value: 'bottom-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                },
                {
                  text: '',
                  value: 'left-width',
                  cssVar: '--border-left-width',
                  customProperties: [[`.--${_vm.section.sid}--order-form`, ['border-left', 'var(--border-left-width)']], [`.--${_vm.section.sid}--header`, ['margin-left', '-' + 'var(--border-left-width)']]]
                }
              ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--step`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--step`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
              {
                text: '',
                value: 'top-left-radius',
                cssVar: '--border-top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius',
                cssVar: '--border-top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius',
                cssVar: '--border-bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius',
                cssVar: '--border-bottom-right-radius'
              }
            ]}})]},proxy:true}],null,false,318926019)})],1):_vm._e(),(_vm.section.options.content.orderForm.stepType !== 'hide')?_c('SidbearSettingsGroup',{attrs:{"title":"Step Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--step`,"rule-name":"padding","min":0,"angles":[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--control`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]}})],1):_vm._e()],2),_c('SidbearSettingsGroup',{attrs:{"active":"","title":"Form Fields"}},[_c('wizard-rule-tabs',{attrs:{"steps":_vm.section.options.content.orderForm.steps.length,"active":_vm.form.step,"current-step":_vm.form.step,"show-confirmation":_vm.section.options.content.orderForm.confirmation[0].options.show},on:{"change":step => _vm.SET_STEP({id: _vm.section.uid, step: step})}},[_c('template',{slot:_vm.form.step},[_c('div',[_c('b-form-group',{staticClass:"mb-[20px]"},[_c('b-checkbox',{on:{"change":function($event){return _vm.SET_STEP({id: _vm.section.uid, step: 0})}},model:{value:(_vm.section.options.content.orderForm.confirmation[0].options.show),callback:function ($$v) {_vm.$set(_vm.section.options.content.orderForm.confirmation[0].options, "show", $$v)},expression:"section.options.content.orderForm.confirmation[0].options.show"}},[_vm._v(" Show Confirmation Step ")])],1),_c('form-field-v3',{attrs:{"current-step":_vm.form.step,"confirmation-step":_vm.form.step === 99,"section":_vm.section,"form":_vm.form}})],1)])],2)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Background"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--order-form`}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--order-form`,"presudo":":hover"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border-style","searchable":false,"options":[
                {
                  label: 'Solid',
                  value: 'solid'
                }, 
                {
                  label: 'Dashed', 
                  value: 'dashed'
                }, 
                {
                  label: 'Dotted', 
                  value: 'dotted'
                }, 
                {
                  label: 'Double', 
                  value: 'double'
                }, 
                {
                  label: 'Outset', 
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--order-form`,"label":"Border Width","rule-name":"border","angles":[
              {
                text: '',
                value: 'top-width',
                cssVar: '--border-top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border-style","searchable":false,"presudo":":hover","options":[
                {
                  label: 'Solid', 
                  value: 'solid'
                }, 
                {
                  label: 'Dashed', 
                  value: 'dashed'
                }, 
                {
                  label: 'Dotted', 
                  value: 'dotted'
                }, 
                {
                  label: 'Double', 
                  value: 'double'
                }, 
                {
                  label: 'Outset', 
                  value: 'outset'
                }
              ]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--order-form`,"label":"Border Width","rule-name":"border","presudo":":hover","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border-color","presudo":":hover"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--order-form`,"rule-name":"border","presudo":":hover","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('rule-tabs',{scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"box-shadow"}})],1)]},proxy:true},{key:"Hover",fn:function(){return [_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--order-form`,"rule-name":"box-shadow","presudo":":hover"}})],1)]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--content`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--order-form`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }